<template>
  <div class="homePage mr-n2" ref="pageSizeMobile">
    <!-- On Dialog -->
    <v-dialog v-model="onDialog" max-width="350" class="onDialog">
      <v-card class="onCard">
        <v-card-title class="headline"> Riasztó bekapcsolása </v-card-title>
        <v-card-text> Biztosan be szeretné kapcsolni a riasztót? </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="setSmsInProgress">
            Igen
          </v-btn>
          <v-btn color="cyan darken-2" text @click="onDialog = false">
            Nem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Off Dialog -->
    <v-dialog v-model="offDialog" max-width="350" class="offDialog">
      <v-card class="offCard">
        <v-card-title class="headline"> Riasztó kikapcsolása </v-card-title>
        <v-card-text> Biztosan ki szeretné kapcsolni a riasztót? </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="setSmsInProgress">
            Igen
          </v-btn>
          <v-btn color="cyan darken-2" text @click="offDialog = false">
            Nem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :absolute="isMobile"
      v-model="$store.state.snackbarTrigger"
      :timeout="3000"
    >
      {{ $store.state.snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="$store.commit('setSnackbarTrigger', false)"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Mobile -->
    <v-row
      align="center"
      justify="space-around"
      class="mt-12"
      v-if="isMobile && $store.state.currentPage === 'home'"
    >
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('data')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue"> mdi-account-circle </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>Adatok</h4>
          </v-col>
        </v-row>
      </v-btn>
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('events1')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue"> mdi-clock </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>24 óra</h4>
          </v-col>
        </v-row>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      justify="space-around"
      class="mt-6"
      v-if="isMobile && $store.state.currentPage === 'home'"
    >
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('events30')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue"> mdi-calendar </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>30 nap</h4>
          </v-col>
        </v-row>
      </v-btn>
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('email')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon v-if="!$store.state.user.isAdmin" size="60" color="blue">
              mdi-mail
            </v-icon>
            <v-icon v-if="$store.state.user.isAdmin" size="60" color="blue">
              mdi-cog
            </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4 v-if="!$store.state.user.isAdmin">E-mail</h4>
            <h4 v-if="$store.state.user.isAdmin">Szerelés</h4>
          </v-col>
        </v-row>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      justify="space-around"
      class="mt-6"
      v-if="isMobile && $store.state.currentPage === 'home'"
    >
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('receipts')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue"> mdi-receipt-text </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>Számlák</h4>
          </v-col>
        </v-row>
      </v-btn>
      <v-btn
        :disabled="!this.$store.state.user.SMSNUM"
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="
          () => {
            if (this.$store.state.alarm) {
              offDialog = true;
            } else if (!this.$store.state.alarm) {
              onDialog = true;
            }
          }
        "
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue" v-if="!$store.state.alarm">
              mdi-lock-open
            </v-icon>
            <v-icon size="60" color="blue" v-if="$store.state.alarm">
              mdi-lock
            </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4 v-if="!$store.state.alarm">Bekapcsolás</h4>
            <h4 v-if="$store.state.alarm">Kikapcsolás</h4>
          </v-col>
        </v-row>
      </v-btn>
      <v-btn
        v-if="this.$store.state.user.isAdmin && !isMobile"
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click="changePage('admin')"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue">mdi-shield-account</v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>Admin</h4>
          </v-col>
        </v-row>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      justify="space-around"
      class="mt-6 mb-n6"
      v-if="isMobile && $store.state.currentPage === 'home'"
    >
      <v-btn
        outlined
        color="grey"
        height="130"
        width="130"
        rounded
        @click.prevent="logout"
      >
        <v-row align="center" justify="center" class="d-flex">
          <v-col cols="12">
            <v-icon size="60" color="blue"> mdi-logout </v-icon>
          </v-col>
          <v-col cols="12" class="mt-n4 grey--text text--darken-4">
            <h4>Kilépés</h4>
          </v-col>
        </v-row>
      </v-btn>
    </v-row>

    <!-- Desktop -->
    <v-row class="d-flex my-1" align="center" justify="center" v-if="!isMobile">
      <v-col class="d-flex align-center justify-center mt-12" ref="pageSize">
        <!-- User Data -->
        <v-card
          color="grey lighten-2"
          elevation="6"
          rounded
          class="px-8 mt-n5 rounded-xl"
          v-if="
            $store.state.currentPage === 'data' ||
            $store.state.currentPage === 'home'
          "
        >
          <v-row class="mt-2 mb-2" align="center" justify="center">
            <v-col cols="11" class="d-flex align-center justify-center">
              <v-card
                color="grey lighten-3"
                elevation="7"
                class="mr-2 rounded-xl"
              >
                <h4 class="mx-4 my-2 text-center">Felhasználói adatok</h4>
              </v-card>
            </v-col>
            <!-- Left block -->
            <v-col class="align-center justify-start" cols="4">
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Felhasználónév:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Név:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Szerződött név:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">E-mail:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Mobilszám:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Azonosító:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Cég:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Vonalszám:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Objektum:</h4>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <!-- Right block -->
            <v-col class="align-center justify-start" cols="6">
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.USERNAME"
                  >
                    {{ $store.state.user.USERNAME }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.NEV"
                  >
                    {{ $store.state.user.NEV }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.SZERZ_NEV"
                  >
                    {{ $store.state.user.SZERZ_NEV }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.EMAIL"
                  >
                    {{ $store.state.user.EMAIL }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.MOBILSZAM"
                  >
                    {{ $store.state.user.MOBILSZAM }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4 class="mx-2 my-2 text-center" v-if="$store.state.user">
                    {{ $store.state.user.ACCOUNT }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.CEG"
                  >
                    {{ $store.state.user.CEG }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.LINE"
                  >
                    {{ $store.state.user.LINE }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h4
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.OBJEKTUM"
                  >
                    {{ $store.state.user.OBJEKTUM }}
                  </h4>
                  <h4 class="mx-2 my-2 text-center" v-else>Nincs adat</h4>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <!-- Events -->

        <Events
          v-if="$store.state.currentPage == 'events1'"
          eventType="events1"
        />

        <Events
          v-if="$store.state.currentPage == 'events30'"
          eventType="events30"
        />

        <!-- Receipts -->
        <Receipts v-if="$store.state.currentPage == 'receipts'" />

        <!-- Admin -->
        <Admin v-if="$store.state.currentPage == 'admin'" />

        <!-- E-mail -->
        <v-card
          color="grey lighten-2"
          min-width="400"
          v-if="
            !$store.state.user.isAdmin && $store.state.currentPage == 'email'
          "
          class="rounded-xl mt-n5"
        >
          <v-row class="d-flex" align="center" justify="center">
            <v-col class="d-flex align-center justify-start" cols="10">
              <h3 class="mx-4 mt-6 text-center">Lépjen velünk kapcsolatba</h3>
            </v-col>
            <v-col
              class="d-flex mt-6 align-center justify-start mr-8 ml-n6"
              cols="1"
            >
              <v-icon size="38" color="blue">mdi-mail</v-icon>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n2 mb-n12" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="name"
                solo
                rounded
                label="Név"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n6 mb-n6" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field v-model="email" solo rounded label="E-mail">
                <template v-slot:prepend-inner>
                  <h3 class="ml-n2 mr-2">@</h3>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-text-field
                v-model="subject"
                solo
                rounded
                label="Tárgy"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n11" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-textarea
                auto-grow
                v-model="message"
                solo
                rounded
                label="Üzenet"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mt-n10" align="center" justify="end">
            <v-col class="d-flex align-center justify-end mx-6">
              <v-btn rounded color="blue" class="mb-2" @click="sendMessage">
                <v-icon color="white">mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Admin form instead of email -->
        <v-card
          v-if="$store.state.user.isAdmin && $store.state.currentPage == 'email'"
          color="grey lighten-2"
          class="rounded-xl mt-n5 admin-suspension-card"
        >
          <v-row class="d-flex mt-2 mb-2" align="center" justify="center" no-gutters>
            <v-col class="d-flex align-center justify-center" cols="12">
              <h3 class="mx-4 text-center">Szerelési felfüggesztés</h3>
              <v-icon size="38" color="blue">mdi-cog</v-icon>
            </v-col>
            
          </v-row>
        
          <v-row class="d-flex mt-n2 mb-n12" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="service_line"
                solo
                rounded
                label="Vonalszám"
                maxlength="2"
                type="number"
              >
                <template v-slot:append>
                  <v-icon>mdi-phone-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        
          <v-row class="d-flex mt-n6 mb-n12" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="service_account"
                solo
                rounded
                label="Vevőszám"
                maxlength="4"
                type="number"
              >
                <template v-slot:append>
                  <v-icon>mdi-account-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        
          <v-row class="d-flex mt-n6 mb-n12" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-select
                v-model="service_minutes"
                :items="
                  Array.from({ length: 120 }, (_, i) => ({
                    text: `${i + 1} perc`,
                    value: i + 1,
                  }))
                "
                item-title="text"
                item-value="value"
                solo
                rounded
                label="Időtartam (perc)"
              ></v-select>
            </v-col>
          </v-row>
        
          <!-- NEW: Start Time Picker -->
          <v-row class="d-flex mt-n6 mb-n12" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="service_starttime"
                solo
                rounded
                label="Kezdési idő"
                readonly
                @click="timePickerDialog = true"
              >
                <template v-slot:append>
                  <v-icon @click="timePickerDialog = true">mdi-clock-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        
          <!-- NEW: Start Date Picker -->
          <v-row class="d-flex mt-n6" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="service_startdate"
                solo
                rounded
                label="Kezdési dátum"
                readonly
                @click="datePickerDialog = true"
              >
                <template v-slot:append>
                  <v-icon @click="datePickerDialog = true">mdi-calendar</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        
          <!-- NEW: Status Block -->
          <v-row class="d-flex mb-8" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-card color="grey lighten-3" elevation="2" class="rounded-xl pa-4">
                <v-row align="center" justify="space-between">
                  <v-col cols="auto">
                    <h4 class="text-center">Státusz</h4>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      small
                      rounded
                      color="grey"
                      @click="refreshSuspensionState"
                      :loading="statusLoading"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                
                <v-divider class="my-2"></v-divider>
                
                <div v-if="statusLoading" class="text-center">
                  <v-progress-circular indeterminate color="blue" size="24"></v-progress-circular>
                  <p class="mt-2">Állapot ellenőrzése...</p>
                </div>
                
                <div v-else-if="suspensionState">
                  <v-row align="center" justify="center">
                    <v-col cols="12" class="text-center">
                      <v-chip
                        :color="suspensionState.state === 'A' ? 'red' : 'green'"
                        text-color="white"
                        class="mb-2"
                      >
                        {{ suspensionState.state === 'A' ? 'Teszt inaktív' : 'Teszt aktív' }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  
                  <div v-if="suspensionState.state !== 'A'">
                    <v-row align="center" justify="center" class="mt-2">
                      <v-col cols="12" class="text-center">
                        <strong>Lejárati dátum:</strong><br>
                        {{ formatDateTime(suspensionState.kivezetve) }}
                      </v-col>
                    </v-row>
                    
                    <v-row align="center" justify="center" class="mt-3">
                      <v-col cols="12" class="text-center">
                        <v-btn
                          rounded
                          color="orange"
                          @click="suspendService"
                          :loading="suspensionLoading"
                        >
                          <v-icon left>mdi-pause</v-icon>
                          Felfüggesztés
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                
                <div v-else class="text-center">
                  <p>Adja meg a vonalszámot és vevőszámot az állapot ellenőrzéséhez</p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        
          <v-row class="mt-n10" align="center" justify="end">
            <v-col class="d-flex align-center justify-end mx-6">
              <v-btn 
                rounded 
                color="blue" 
                class="mb-2" 
                @click="sendMessage"
                :loading="sendLoading"
              >
                <v-icon color="white">mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Time Picker Dialog -->
        <v-dialog v-model="timePickerDialog" max-width="340px">
          <v-card>
            <v-card-title>Kezdési idő kiválasztása</v-card-title>
            <v-card-text>
              <v-time-picker
                v-model="selectedTime"
                format="24hr"
                :min="getMinTime()"
                @update:model-value="updateTime"
              ></v-time-picker>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="timePickerDialog = false">Mégse</v-btn>
              <v-btn color="blue" text @click="confirmTime">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!-- Date Picker Dialog -->
        <v-dialog v-model="datePickerDialog" max-width="340px">
          <v-card>
            <v-card-title>Kezdési dátum kiválasztása</v-card-title>
            <v-card-text>
              <v-date-picker
                v-model="selectedDate"
                :min="getCurrentDate()"
                @update:model-value="updateDate"
              ></v-date-picker>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="datePickerDialog = false">Mégse</v-btn>
              <v-btn color="blue" text @click="confirmDate">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-col>
    </v-row>

    <!-- Mobile -->
    <v-row class="mt-n10 mx-1" justify="center" v-if="isMobile">
      <v-col class="d-flex align-center justify-center mt-12">
        <!-- User Data -->
        <v-card
          color="grey lighten-2"
          elevation="6"
          rounded
          class="py-5 rounded-xl"
          v-if="$store.state.currentPage === 'data'"
        >
          <v-row align="center" justify="center">
            <v-col cols="1" class="d-flex align-center justify-start">
              <v-btn
                rounded
                small
                @click.prevent="$store.state.currentPage = 'home'"
              >
                <v-icon size="20"> mdi-arrow-left-thick </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10" class="d-flex align-center justify-center">
              <v-card
                color="grey lighten-3"
                elevation="7"
                class="mr-2 rounded-xl"
              >
                <h5 class="mx-4 my-2 text-center">Felhasználói adatok</h5>
              </v-card>
            </v-col>
            <!-- Left block -->
            <v-col class="align-center justify-start ml-2 mr-n12">
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Felhasználónév:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Név:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Szerződött név:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">E-mail:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Mobilszám:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h4 class="mx-4 my-2 text-center">Azonosító:</h4>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Cég:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Vonalszám:</h5>
                  </v-card>
                </v-col>
              </v-row>
              <v-spacer class="my-1"></v-spacer>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <v-card
                    color="grey lighten-3"
                    elevation="7"
                    class="mr-2 rounded-xl"
                  >
                    <h5 class="mx-4 my-2 text-center">Objektum:</h5>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <!-- Right block -->
            <v-col class="align-center justify-start ml-n12">
              <v-row align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.USERNAME"
                  >
                    {{ $store.state.user.USERNAME }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.NEV"
                  >
                    {{ $store.state.user.NEV }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.SZERZ_NEV"
                  >
                    {{ $store.state.user.SZERZ_NEV }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.EMAIL"
                  >
                    {{ $store.state.user.EMAIL }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.MOBILSZAM"
                  >
                    {{ $store.state.user.MOBILSZAM }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5 class="mx-2 my-2 text-center" v-if="$store.state.user">
                    {{ $store.state.user.ACCOUNT }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.CEG"
                  >
                    {{ $store.state.user.CEG }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.LINE"
                  >
                    {{ $store.state.user.LINE }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row class="d-flex" align="center" justify="start">
                <v-col class="d-flex align-center justify-start">
                  <h5
                    class="mx-2 my-2 text-center"
                    v-if="$store.state.user.OBJEKTUM"
                  >
                    {{ $store.state.user.OBJEKTUM }}
                  </h5>
                  <h5 class="mx-2 my-2 text-center" v-else>Nincs adat</h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <!-- Events -->
        <Events
          v-if="$store.state.currentPage == 'events1'"
          eventType="events1"
        />
        <Events
          v-if="$store.state.currentPage == 'events30'"
          eventType="events30"
        />
        <!-- Receipts -->
        <Receipts v-if="$store.state.currentPage == 'receipts'" />
        <!-- Admin -->
        <Admin v-if="$store.state.currentPage == 'admin'" />
        <!-- E-mail -->
        <v-card
          color="grey lighten-2"
          min-width="360"
          v-if="
            !$store.state.user.isAdmin && $store.state.currentPage == 'email'
          "
          class="rounded-xl mx-2"
        >
          <v-row class="d-flex" align="center" justify="center">
            <v-col cols="1" class="d-flex align-center justify-start">
              <v-btn
                rounded
                small
                @click.prevent="$store.state.currentPage = 'home'"
              >
                <v-icon size="20"> mdi-arrow-left-thick </v-icon>
              </v-btn>
            </v-col>
            <v-col class="d-flex align-center justify-end" cols="9">
              <h4 class="mx-4 mt-6 text-center blue--text">
                Lépjen velünk kapcsolatba
              </h4>
            </v-col>
            <v-col
              class="d-flex mt-6 align-center justify-start mr-8 ml-n6"
              cols="1"
            >
              <v-icon size="25" color="blue">mdi-mail</v-icon>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n2 mb-n12" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="name"
                solo
                rounded
                label="Név"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n6 mb-n6" align="center" justify="center">
            <v-col class="d-flex align-center justify-center mx-6">
              <v-text-field
                v-model="email"
                @focus="changeEmailIcon"
                solo
                rounded
                label="E-mail"
              >
                <template v-slot:prepend-inner>
                  <h3 class="ml-n2 mr-2">@</h3>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-text-field
                v-model="subject"
                solo
                rounded
                label="Tárgy"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex mt-n11" align="center" justify="center">
            <v-col class="align-center justify-center mx-6">
              <v-textarea
                auto-grow
                v-model="message"
                solo
                rounded
                label="Üzenet"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mt-n10" align="center" justify="end">
            <v-col class="d-flex align-center justify-end mx-6">
              <v-btn rounded color="blue" class="mb-2" @click="sendMessage">
                <v-icon color="white">mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Admin form instead of email -->
        <v-row justify="center" class="px-4">
          <v-col cols="12">
            <!-- Admin form instead of email -->
            <v-card
              color="grey lighten-2"
              v-if="$store.state.user.isAdmin && $store.state.currentPage == 'email'"
              class="rounded-xl mt-n5"
            >
                <v-row class="d-flex mb-n6" align="center" justify="center" no-gutters>
                    <v-col cols="12" class="d-flex align-center justify-start mt-2 ml-4">
                      <v-btn
                        rounded
                        small
                        @click.prevent="$store.state.currentPage = 'home'"
                      >
                        <v-icon size="20"> mdi-arrow-left-thick </v-icon>
                      </v-btn>
                    </v-col>
                  
                </v-row>
                <v-row class="d-flex" align="center" justify="center" no-gutters>
                    
                  <v-col class="d-flex align-center justify-center" cols="9">
                    <div class="d-flex align-center flex-nowrap">
                      <h3 class="mx-4 mt-6 text-center flex-shrink-0">Szerelési felfüggesztés</h3>
                      <v-icon size="38" color="blue" class="mt-6 ml-2 flex-shrink-0">mdi-cog</v-icon>
                    </div>
                  </v-col>
                </v-row>


              <v-row
                class="d-flex mt-n2 mb-n12"
                align="center"
                justify="center"
              >
                <v-col class="d-flex align-center justify-center mx-6">
                  <v-text-field
                    v-model="service_line"
                    solo
                    rounded
                    label="Vonalszám"
                    maxlength="2"
                    type="number"
                  >
                    <template v-slot:append>
                      <v-icon>mdi-phone-outline</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row
                class="d-flex mt-n6 mb-n12"
                align="center"
                justify="center"
              >
                <v-col class="d-flex align-center justify-center mx-6">
                  <v-text-field
                    v-model="service_account"
                    solo
                    rounded
                    label="Vevőszám"
                    maxlength="4"
                    type="number"
                  >
                    <template v-slot:append>
                      <v-icon>mdi-account-outline</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row
                class="d-flex mt-n6 mb-n12"
                align="center"
                justify="center"
              >
                <v-col class="align-center justify-center mx-6">
                  <v-select
                    v-model="service_minutes"
                    :items="
                      Array.from({ length: 120 }, (_, i) => ({
                        text: `${i + 1} perc`,
                        value: i + 1,
                      }))
                    "
                    item-title="text"
                    item-value="value"
                    solo
                    rounded
                    label="Időtartam (perc)"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- NEW: Start Time Picker -->
              <v-row
                class="d-flex mt-n6 mb-n12"
                align="center"
                justify="center"
              >
                <v-col class="d-flex align-center justify-center mx-6">
                  <v-text-field
                    v-model="service_starttime"
                    solo
                    rounded
                    label="Kezdési idő"
                    readonly
                    @click="timePickerDialog = true"
                  >
                    <template v-slot:append>
                      <v-icon @click="timePickerDialog = true"
                        >mdi-clock-outline</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- NEW: Start Date Picker -->
              <v-row class="d-flex mt-n6 mb-n8" align="center" justify="center">
                <v-col class="d-flex align-center justify-center mx-6">
                  <v-text-field
                    v-model="service_startdate"
                    solo
                    rounded
                    label="Kezdési dátum"
                    readonly
                    @click="datePickerDialog = true"
                  >
                    <template v-slot:append>
                      <v-icon @click="datePickerDialog = true"
                        >mdi-calendar</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- NEW: Status Block -->
              <v-row class="d-flex mb-8" align="center" justify="center">
                <v-col class="align-center justify-center mx-6">
                  <v-card
                    color="grey lighten-3"
                    elevation="2"
                    class="rounded-xl pa-4"
                  >
                    <v-row align="center" justify="space-between">
                      <v-col cols="auto">
                        <h4 class="text-center">Státusz</h4>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn
                          small
                          rounded
                          color="grey"
                          @click="refreshSuspensionState"
                          :loading="statusLoading"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider class="my-2"></v-divider>

                    <div v-if="statusLoading" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="blue"
                        size="24"
                      ></v-progress-circular>
                      <p class="mt-2">Állapot ellenőrzése...</p>
                    </div>

                    <div v-else-if="suspensionState">
                      <v-row align="center" justify="center">
                        <v-col cols="12" class="text-center">
                          <v-chip
                            :color="
                              suspensionState.state === 'A' ? 'red' : 'green'
                            "
                            text-color="white"
                            class="mb-2"
                          >
                            {{
                              suspensionState.state === "A"
                                ? "Teszt inaktív"
                                : "Teszt aktív"
                            }}
                          </v-chip>
                        </v-col>
                      </v-row>

                      <div v-if="suspensionState.state !== 'A'">
                        <v-row align="center" justify="center" class="mt-2">
                          <v-col cols="12" class="text-center">
                            <strong>Lejárati dátum:</strong><br />
                            {{ formatDateTime(suspensionState.kivezetve) }}
                          </v-col>
                        </v-row>

                        <v-row align="center" justify="center" class="mt-3">
                          <v-col cols="12" class="text-center">
                            <v-btn
                              rounded
                              color="orange"
                              @click="suspendService"
                              :loading="suspensionLoading"
                            >
                              <v-icon left>mdi-pause</v-icon>
                              Felfüggesztés
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <div v-else class="text-center">
                      <p>
                        Adja meg a vonalszámot és vevőszámot az állapot
                        ellenőrzéséhez
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="mt-n10" align="center" justify="end">
                <v-col class="d-flex align-center justify-end mx-6">
                  <v-btn
                    rounded
                    color="blue"
                    class="mb-2"
                    @click="sendMessage"
                    :loading="sendLoading"
                  >
                    <v-icon color="white">mdi-send</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-dialog v-model="timePickerDialog" max-width="340px">
              <v-card>
                <v-card-title>Kezdési idő kiválasztása</v-card-title>
                <v-card-text>
                  <v-time-picker
                    v-model="selectedTime"
                    format="24hr"
                    @update:model-value="updateTime"
                  ></v-time-picker>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="timePickerDialog = false">Mégse</v-btn>
                  <v-btn color="blue" text @click="confirmTime">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Date Picker Dialog -->
            <v-dialog v-model="datePickerDialog" max-width="340px">
              <v-card>
                <v-card-title>Kezdési dátum kiválasztása</v-card-title>
                <v-card-text>
                  <v-date-picker
                    v-model="selectedDate"
                    @update:model-value="updateDate"
                  ></v-date-picker>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="datePickerDialog = false">Mégse</v-btn>
                  <v-btn color="blue" text @click="confirmDate">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import itemCard from '@/components/home/ItemCard'
import { isMobile } from "mobile-device-detect";
import db from "@/firebase/init.js";
import { collection, addDoc, getDoc, doc } from "firebase/firestore";
import Events from "../components/Events";
import Receipts from "../components/Receipts.vue";
import { StatusIndicator } from "vue-status-indicator";
import Admin from "../components/Admin.vue";
import axios from "axios";

export default {
  name: "HomePage",
  components: {
    StatusIndicator,
    Events,
    Receipts,
    Admin,
  },

  data() {
    return {
      isMobile: isMobile,
      currentPage: "data",
      pages: ["data", "24hours", "30days", "email"],
      name: "",
      onDialog: false,
      offDialog: false,
      email: "",
      interval: null,
      smsTimer: null,
      alarmTimer: null,
      alarmTimer2: null,
      subject: "",
      message: "",
      events: [],
      isAdmin: false,
      adminUsers: [],
      editingUser: null,
      isUpdatingUser: false,
      service_minutes: null,
      service_starttime: new Date().toTimeString().slice(0, 5).replace(":", ""),
      service_startdate: null,
      service_account: this.$store?.state?.user?.ACCOUNT || "",
      service_line: this.$store?.state?.user?.LINE || "",
      timePickerDialog: false,
      datePickerDialog: false,
      selectedTime: null,
      selectedDate: null,
      service_status: "T",
      suspensionState: null,
      statusLoading: false,
      sendLoading: false,
      suspensionLoading: false,
      debounceTimer: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (!this.isMobile) {
      this.$store.state.desktopScrollHeight = window.innerHeight - 278;
    } else {
      this.$store.state.mobileScrollHeight = window.innerHeight - 275;
    }
    if (this.$store.state.user) {
        this.service_account = this.$store.state.user.ACCOUNT || "";
        this.service_line = this.$store.state.user.LINE || "";
      }
    
    //Set service_startdate
    const now = new Date();
    // Format date as YYMMDD (last 2 digits of year + month + day)
    const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Month (0-indexed, so +1)
    const day = now.getDate().toString().padStart(2, '0'); // Day
    this.service_startdate = year + month + day;
  },

  computed: {
    userState() {
      return this.$store.state.user;
    },
    isUserAdmin() {
      return this.$store.state.user?.isAdmin || false;
    },
  },

  created() {
    this.checkAdminStatus();
  },

  watch: {
    "$store.state.currentPage": {
      handler(newValue, oldValue) {
        if(newValue == 'email' && this.$store.state.user.isAdmin){
          this.checkSuspensionState();
        }
      },
      deep: true,
      immediate: true,
    },
    "$store.state.user": {
      handler(newUser, oldUser) {
        if (newUser) {
            this.service_account = newUser.ACCOUNT || "";
            this.service_line = newUser.LINE || "";
          }
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
    
    
    
    
    service_account() {
        this.debouncedCheckSuspensionState();
      },
      
      service_line() {
        this.debouncedCheckSuspensionState();
      },
    userState: {
      handler(newValue, oldValue) {
        if (
          !this.isUpdatingUser &&
          newValue &&
          newValue.LINE &&
          newValue.ACCOUNT
        ) {
          const lineChanged = !oldValue || oldValue.LINE !== newValue.LINE;
          const accountChanged =
            !oldValue || oldValue.ACCOUNT !== newValue.ACCOUNT;

          if (lineChanged || accountChanged) {
            this.fetchUserData(newValue.LINE, newValue.ACCOUNT);
          }
        }
      },
      deep: true,
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    
    // Get current date in YYYY-MM-DD format
      getCurrentDate() {
        const now = new Date();
        return now.toISOString().split('T')[0];
      },
    
      // Get minimum time (current time if today is selected, otherwise null)
      getMinTime() {
        if (!this.service_startdate) return null;
        
        const today = new Date();
        const todayStr = today.getFullYear().toString() + 
                        (today.getMonth() + 1).toString().padStart(2, '0') + 
                        today.getDate().toString().padStart(2, '0');
        
        // If selected date is today, set minimum time to current time
        if (this.service_startdate === todayStr) {
          return today.toTimeString().slice(0, 5);
        }
        return null;
      },
    
      // Validate and adjust start datetime if it's in the past
      validateAndAdjustDateTime(startDate, startTime) {
        const now = new Date();
        
        // Parse the selected datetime
        const year = parseInt(startDate.substring(0, 4));
        const month = parseInt(startDate.substring(4, 6)) - 1; // Month is 0-indexed
        const day = parseInt(startDate.substring(6, 8));
        const hour = parseInt(startTime.substring(0, 2));
        const minute = parseInt(startTime.substring(2, 4));
        
        const selectedDateTime = new Date(year, month, day, hour, minute);
        
        // If selected time is in the past, set to current time
        if (selectedDateTime < now) {
          const nowYear = now.getFullYear().toString();
          const nowMonth = (now.getMonth() + 1).toString().padStart(2, '0');
          const nowDay = now.getDate().toString().padStart(2, '0');
          const nowHour = now.getHours().toString().padStart(2, '0');
          const nowMinute = now.getMinutes().toString().padStart(2, '0');
          
          return {
            date: nowYear + nowMonth + nowDay,
            time: nowHour + nowMinute,
            adjusted: true
          };
        }
        
        return {
          date: startDate,
          time: startTime,
          adjusted: false
        };
      },
    
      // Updated confirmTime method
      confirmTime() {
        if (this.selectedTime) {
          const timeStr = this.selectedTime.replace(":", "");
          
          // Validate if the combination of date and time is not in the past
          if (this.service_startdate) {
            const validation = this.validateAndAdjustDateTime(this.service_startdate, timeStr);
            
            if (validation.adjusted) {
              this.service_startdate = validation.date;
              this.service_starttime = validation.time;
              
              // Show warning to user
              this.$store.commit("setSnackbarMessage", "A kezdési idő a jelenlegi időre lett állítva, mert múltbeli időt választott!");
              this.$store.commit("setSnackbarTimeout", 4000);
              this.$store.commit("setSnackbarTrigger", true);
            } else {
              this.service_starttime = timeStr;
            }
          } else {
            this.service_starttime = timeStr;
          }
        }
        this.timePickerDialog = false;
      },
    
      // Updated confirmDate method
      confirmDate() {
        if (this.selectedDate) {
          const dateObj = new Date(this.selectedDate);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const day = String(dateObj.getDate()).padStart(2, "0");
          const newDate = `${year}${month}${day}`;
          
          // If changing to today and current time is set, validate time
          if (this.service_starttime) {
            const validation = this.validateAndAdjustDateTime(newDate, this.service_starttime);
            
            if (validation.adjusted) {
              this.service_startdate = validation.date;
              this.service_starttime = validation.time;
              
              this.$store.commit("setSnackbarMessage", "A kezdési dátum és idő a jelenlegi időre lett állítva!");
              this.$store.commit("setSnackbarTimeout", 4000);
              this.$store.commit("setSnackbarTrigger", true);
            } else {
              this.service_startdate = newDate;
            }
          } else {
            this.service_startdate = newDate;
          }
        }
        this.datePickerDialog = false;
      },
    updateTime(time) {
      this.selectedTime = time;
    },

    confirmTime() {
      if (this.selectedTime) {
        // Convert time to HHMM format for database
        this.service_starttime = this.selectedTime.replace(":", "");
      }
      this.timePickerDialog = false;
    },

    updateDate(date) {
      this.selectedDate = date;
    },

    debouncedCheckSuspensionState() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        if (this.service_account && this.service_line) {
          this.checkSuspensionState();
        }
      }, 500); // 500ms delay
    },

    // Check suspension state
    async checkSuspensionState() {
      
      if (!this.service_account || !this.service_line) {
        this.suspensionState = null;
        return;
      }
    
      this.statusLoading = true;
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + "/my_monitoring_api.php",
          {
            params: {
              eventType: "serviceSuspensionState",
              account: String(this.service_account).trim(),
              line: String(this.service_line).trim(),
            },
            withCredentials: true,
          }
        );
    
    
        if (response.data.error) {
          console.error("Error:", response.data.error);
          this.suspensionState = null;
        } else {
          this.suspensionState = response.data;
        }
      } catch (error) {
        console.error("Error checking suspension state:", error);
        this.suspensionState = null;
      } finally {
        this.statusLoading = false;
      }
    },


    // Refresh suspension state manually
    async refreshSuspensionState() {
      await this.checkSuspensionState();
    },

    confirmDate() {
      if (this.selectedDate) {
        // Convert date to YYYYMMDD format for database
        const dateObj = new Date(this.selectedDate);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        this.service_startdate = `${year}${month}${day}`;
      }
      this.datePickerDialog = false;
    },
    async fetchUserData(line, account) {
      this.isUpdatingUser = true;

      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + "/my_monitoring_api.php",
          {
            params: {
              eventType: "getUser",
              line: line,
              account: account,
            },
            withCredentials: true,
          }
        );

        if (Array.isArray(response.data) && response.data.length > 0) {

          // Preserve the isAdmin flag and merge with new data
          const updatedUser = {
            ...response.data[0],
            isAdmin: this.$store.state.user?.isAdmin || false,
          };

          this.$store.commit("setUser", updatedUser);
        } else {
          console.error("Invalid user data format received:", response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        throw error; // Re-throw to handle in calling method
      } finally {
        this.isUpdatingUser = false;
      }
    },
    
    // Suspend service (set to A state with 5 minutes)
      async suspendService() {
        this.suspensionLoading = true;
        try {
          const now = new Date();
          const year = now.getFullYear().toString().slice(-2);
          const month = (now.getMonth() + 1).toString().padStart(2, '0');
          const day = now.getDate().toString().padStart(2, '0'); 
          const currentDate = year + month + day;
          const currentTime = now.toTimeString().slice(0, 5).replace(":", "");
          
          const response = await axios.post(
            process.env.VUE_APP_API_URL + "/my_monitoring_api.php",
            {
              uid: this.$store.state.user.TOKEN,
              eventType: "serviceSuspension",
              account: this.service_account,
              line: this.service_line,
              raszerkod: this.$store.state.raszerkod,
              status: "A",
              minutes: 90,
              starttime: currentTime,
              startdate: currentDate,
            },
            {
              withCredentials: true,
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
    
          if (response.data.success === true) {
            this.$store.commit("setSnackbarMessage", "Felfüggesztés sikeresen beállítva!");
            this.$store.commit("setSnackbarTimeout", 3000);
            this.$store.commit("setSnackbarTrigger", true);
            
            // Refresh the status
            await this.checkSuspensionState();
          } else {
            // Use the message from the API response if available, otherwise use default
            const errorMessage = response.data.message || "Hiba történt a felfüggesztés során!";
            this.$store.commit("setSnackbarMessage", errorMessage);
            this.$store.commit("setSnackbarTimeout", 3000);
            this.$store.commit("setSnackbarTrigger", true);
          }

        } catch (error) {
          console.error(error);
          this.$store.commit("setSnackbarMessage", "Adatbázis kapcsolat sikertelen!");
          this.$store.commit("setSnackbarTimeout", 3000);
          this.$store.commit("setSnackbarTrigger", true);
        } finally {
          this.suspensionLoading = false;
        }
      },
    
      // Format datetime for display
      formatDateTime(dateTimeStr) {
        if (!dateTimeStr) return '';
        const date = new Date(dateTimeStr);
        return date.toLocaleString('hu-HU');
      },

    async checkAdminStatus() {
      try {
        const adminDocRef = collection(db, "admin");
        const usersDocRef = doc(adminDocRef, "users");
        const docSnap = await getDoc(usersDocRef);

        if (docSnap.exists()) {
          const adminUsernames = docSnap.data().usernames || [];
          this.adminUsers = adminUsernames;
          this.$store.state.user.isAdmin = adminUsernames.includes(
            this.$store.state.user.USERNAME
          );
          this.$forceUpdate();
        }
      } catch (error) {
        console.error("Error checking admin status:", error);
      }
    },
    onResize() {
      if (!this.isMobile) {
        this.$store.state.desktopScrollHeight = window.innerHeight - 278;
      } else {
        this.$store.state.mobileScrollHeight = window.innerHeight - 275;
      }
    },
    logout() {
      this.$store.commit("setUser", null);
      if (this.$route.name != "Login") {
        this.$router.push({ name: "Login" });
      }
      this.$store.state.currentPage = "home";
    },
    setSmsInProgress() {
      this.offDialog = false;
      this.onDialog = false;
      if (!this.$store.state.smsInProgress) {
        this.$store.state.smsInProgress = true;
      } else {
        this.$store.commit("setSnackbarTrigger", false);
        setTimeout(
          () =>
            this.delayedNotification(
              "A be/ki riasztás már folyamatban van!",
              3000,
              true
            ),
          100
        );
      }
    },
    delayedNotification(message, timeout, bool) {
      this.$store.commit("setSnackbarMessage", message);
      this.$store.commit("setSnackbarTimeout", timeout);
      this.$store.commit("setSnackbarTrigger", bool);
    },
    changePage(page) {
      this.$store.state.currentPage = page;
      if (!this.isMobile) {
        this.$store.state.desktopScrollHeight = window.innerHeight - 278;
      } else {
        this.$store.state.mobileScrollHeight = window.innerHeight - 275;
      }
    },

    async sendMessage() {
      /* -------------------------------------------
       *  ADMIN – service suspension request
       * ----------------------------------------- */
      if (this.$store.state.user.isAdmin) {
        if (
          this.service_line &&
          this.service_account &&
          this.service_minutes &&
          this.service_starttime &&
          this.service_startdate
        ) {
          this.sendLoading = true;
    
          try {
            /* 1. Validate & adjust start date-time --------------------- */
            const now = new Date();
    
            // parse current form values
            const selYear   = parseInt(this.service_startdate.slice(0, 4), 10);
            const selMonth  = parseInt(this.service_startdate.slice(4, 6), 10) - 1; // 0-indexed
            const selDay    = parseInt(this.service_startdate.slice(6, 8), 10);
            const selHour   = parseInt(this.service_starttime.slice(0, 2), 10);
            const selMinute = parseInt(this.service_starttime.slice(2, 4), 10);
            const selected  = new Date(selYear, selMonth, selDay, selHour, selMinute);
    
            // if in the past → shift to "now"
            if (selected < now) {
              const year   = now.getFullYear();
              const month  = String(now.getMonth() + 1).padStart(2, "0");
              const day    = String(now.getDate()).padStart(2, "0");
              const hour   = String(now.getHours()).padStart(2, "0");
              const minute = String(now.getMinutes()).padStart(2, "0");
    
              this.service_startdate = `${year}${month}${day}`; // YYYYMMDD
              this.service_starttime = `${hour}${minute}`;      // HHMM
    
              this.$store.commit(
                "setSnackbarMessage",
                "A múltbeli kezdési időt automatikusan a jelenlegi időre állítottuk!"
              );
              this.$store.commit("setSnackbarTimeout", 4000);
              this.$store.commit("setSnackbarTrigger", true);
            }
    
            /* 2. Send suspension request ------------------------------ */
            const response = await axios.post(
              process.env.VUE_APP_API_URL + "/my_monitoring_api.php",
              {
                uid:        this.$store.state.user.TOKEN,
                eventType:  "serviceSuspension",
                account:    this.service_account,
                line:       this.service_line,
                status:     this.service_status,
                raszerkod:  this.$store.state.raszerkod,
                minutes:    this.service_minutes,
                starttime:  this.service_starttime,
                startdate:  this.service_startdate,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
    
            /* 3. Handle API response ---------------------------------- */
            if (response.data && response.data.success !== false) {
              this.$store.commit(
                "setSnackbarMessage",
                "Szerelési felfüggesztés sikeresen beállítva!"
              );
            } else {
              this.$store.commit(
                "setSnackbarMessage",
                response.data.message || "Hiba történt a beállítás során!"
              );
            }
            this.$store.commit("setSnackbarTimeout", 3000);
            this.$store.commit("setSnackbarTrigger", true);
    
            /* 4. Reset form to current date-time ---------------------- */
            const resetNow = new Date();
            const y  = resetNow.getFullYear();
            const m  = String(resetNow.getMonth() + 1).padStart(2, "0");
            const d  = String(resetNow.getDate()).padStart(2, "0");
            const hh = String(resetNow.getHours()).padStart(2, "0");
            const mm = String(resetNow.getMinutes()).padStart(2, "0");
    
            this.service_minutes   = null;
            this.service_startdate = `${y}${m}${d}`;
            this.service_starttime = `${hh}${mm}`;
    
            // Optionally refresh suspension status
            await this.checkSuspensionState();
          } catch (err) {
            console.error(err);
            this.$store.commit(
              "setSnackbarMessage",
              "Adatbázis-kapcsolat sikertelen!"
            );
            this.$store.commit("setSnackbarTimeout", 3000);
            this.$store.commit("setSnackbarTrigger", true);
          } finally {
            this.sendLoading = false;
          }
        } else {
          this.$store.commit(
            "setSnackbarMessage",
            "Minden mező kitöltése kötelező!"
          );
          this.$store.commit("setSnackbarTimeout", 3000);
          this.$store.commit("setSnackbarTrigger", true);
        }
    
        return; // admin branch ends here
      }
    
      /* -------------------------------------------
       *  NON-ADMIN – regular contact e-mail
       * ----------------------------------------- */
      if (this.subject && this.message) {
        if (!this.name)  this.name  = this.$store.state.user.NEV;
        if (!this.email) this.email = this.$store.state.user.EMAIL;
    
        try {
          await addDoc(collection(db, "mail"), {
            to: "rimi@rimi.hu",
            message: {
              subject: "Ügyfélszolgálati üzenet a rimi.hu oldalról",
              text:
                "Ügyfél neve: "      + this.name    + "\n" +
                "Ügyfél e-mail címe: " + this.email   + "\n" +
                "Tárgy: "             + this.subject + "\n" +
                "Üzenet: "            + this.message,
            },
          });
    
          this.$store.commit("setSnackbarMessage", "Sikeres üzenetküldés!");
          this.name    = "";
          this.email   = "";
          this.subject = "";
          this.message = "";
        } catch (e) {
          console.error("Error adding document: ", e);
          this.$store.commit(
            "setSnackbarMessage",
            "Az üzenetküldés nem sikerült!"
          );
        }
    
        this.$store.commit("setSnackbarTimeout", 3000);
        this.$store.commit("setSnackbarTrigger", true);
      } else {
        this.$store.commit(
          "setSnackbarMessage",
          "Minden mező kitöltése kötelező!"
        );
        this.$store.commit("setSnackbarTimeout", 3000);
        this.$store.commit("setSnackbarTrigger", true);
      }
    },

  },

  beforeDestroy() {
    clearInterval(this.alarmTimer);
    clearInterval(this.interval);
    clearInterval(this.alarmTimer2);
    clearInterval(this.smsTimer);
  },
};
</script>
<style scoped>
/* Desktop-first: 50 % width, comfortable padding */
.admin-suspension-card {
  width: 50%;
  padding-left: 16px;
  padding-right: 16px;
}

/* ≤ md (tablets & small laptops): widen & tighten padding */
@media (max-width: 959px) {
  .admin-suspension-card {
    width: 70%;
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* ≤ sm (phones): full-width & minimal padding */
@media (max-width: 599px) {
  .admin-suspension-card {
    width: 95%;
    padding-left: 8px;
    padding-right: 8px;
  }
}

</style>
